module.exports = __webpack_public_path__ + "img/mob4.067bdbd2.png";